const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// ========== Token 相关 ==========

export function getAccessToken () {
  return localStorage.getItem(AccessTokenKey)
}

export function getRefreshToken () {
  return localStorage.getItem(RefreshTokenKey)
}

export function setToken (token) {
  localStorage.setItem(AccessTokenKey, token.accessToken)
  localStorage.setItem(RefreshTokenKey, token.refreshToken)
}

export function removeToken () {
  localStorage.removeItem(AccessTokenKey)
  localStorage.removeItem(RefreshTokenKey)
}

// ========== 租户相关 ==========

const TenantIdKey = 'TENANT_ID'
const TenantNameKey = 'TENANT_NAME'

export function getTenantName () {
  return localStorage.getItem(TenantNameKey)
}

export function setTenantName (username) {
  localStorage.setItem(TenantNameKey, username)
}

export function removeTenantName () {
  localStorage.removeItem(TenantNameKey)
}

export function getTenantId () {
  return localStorage.getItem(TenantIdKey)
}

export function setTenantId (tenantId) {
  localStorage.setItem(TenantIdKey, tenantId)
}

export function removeTenantId () {
  localStorage.removeItem(TenantIdKey)
}

// ========== 站点信息 ==========
const WebsitBannerKey = 'WEBSIT-BANNER'
const WebsitLogoKey = 'WEBSIT-LOGO'
const WebsitName = 'WEBSIT-NAME'

export function getWebsitBanner () {
  return localStorage.getItem(WebsitBannerKey)
}

export function setWebsitBanner (websit) {
  localStorage.setItem(WebsitBannerKey, websit.bannerPath)
}

export function removeWebsitBanner () {
  localStorage.removeItem(WebsitBannerKey)
}
export function getWebsitLogo () {
  return localStorage.getItem(WebsitLogoKey)
}

export function setWebsitLogo (websit) {
  localStorage.setItem(WebsitLogoKey, websit.siteLogo)
}

export function removeWebsitLogo () {
  localStorage.removeItem(WebsitLogoKey)
}
export function getWebsitName () {
  return localStorage.getItem(WebsitName)
}

export function setWebsitName (websit) {
  console.log(websit.siteName)
  localStorage.setItem(WebsitName, websit.siteName)
}

export function removeWebsitName () {
  localStorage.removeItem(WebsitName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js